import { motion } from 'framer-motion';
import { fadeIn, textVariant } from '../../utils/motion';
import img from '../../assets/banner.webp'
import Typewriter from 'typewriter-effect';
import { Button } from '@mui/material';
import { useGetUrlQuery } from '../../helpers/SendEmailApi';
import { useNavigate } from 'react-router-dom';


const Banner = ({ darkToggle }) => {

    const { data: link } = useGetUrlQuery()
    
    const navigate = useNavigate()

    const handleClick = () => {

        if (link && link.url) {
            window.open(link.url)
        } else {
            // setopen(true)
            navigate('/meetup')
        }

    }

    return (
        <div >

            <div className='z-30 relative  min-h-screen pt-20 lg:pt-0 bg-red-500 transition-all duration-700'>

                <div className="custom-shape-divider-bottom">
                    <svg data-name="Layer 1" stroke='none' fill={darkToggle ? '#111827' : '#ffffff'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                        <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" className="shape-fill"></path>
                    </svg>
                </div>

                <motion.div
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true }}
                    className='lg:pt-[90px]'
                >
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-8  md:px-5 py-4 max-w-screen-2xl mx-auto'>
                        <div className='flex  items-center flex-col px-5'>
                            <motion.h1 variants={textVariant(0.2)} className={'font-bold text-white text-3xl md:text-4xl xl:text-6xl'} viewport={{ once: true }}>
                                Software
                            </motion.h1>
                            <motion.h1 variants={textVariant(0.4)} className={'font-bold text-white text-3xl md:text-4xl xl:text-6xl '} viewport={{ once: true }}>
                                Development
                            </motion.h1>
                            <div className='relative'>
                                <motion.h1 variants={textVariant(0.6)} className={'font-bold text-white text-3xl  md:text-4xl xl:text-6xl '} viewport={{ once: true }}>
                                    Consulting
                                </motion.h1>
                                <div className='flex justify-center absolute top-[20px]  left-0 right-0 w-full'>
                                    <div>
                                        <div className='h-[200px] lg:h-[260px] opacity-20 w-[200px] lg:w-[260px] border-[17px] border-black rounded-full flex justify-center items-center'>
                                            <h1 className='text-[100px] lg:text-[150px] font-semibold text-black'>
                                                CZ
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <motion.h1 variants={textVariant(0.8)} className={'font-bold text-white text-3xl  md:text-4xl xl:text-6xl '} viewport={{ once: true }}>
                                <Typewriter
                                    options={{
                                        strings: ['Innovators', 'Startups', 'Businesses', 'FinTechs', 'Banks', 'Entrepreneurs'],
                                        autoStart: true,
                                        loop: true,
                                    }}
                                />
                            </motion.h1>
                            <motion.h1 variants={textVariant(1.0)} className={'font-bold text-white text-[14px] md:text-[17px]  mt-5 '} viewport={{ once: true }}>
                                CodeZone offers software development consulting services for businesses, startups, enterprises  web applications, Blockchain and NFT marketplaces, AI and ML based websites, Metaverse and WebGL websites. Partner with a reliable software development company to scale up your engineering capacity.
                            </motion.h1>

                            <motion.div variants={textVariant(1.2)} className={'flex justify-center mt-4 lg:mr-11 relative z-20'} viewport={{ once: true }}>
                                <Button
                                    onClick={() => handleClick()}
                                    variant='contained' color='error'
                                    className='blob-btn'
                                    size='large'

                                    sx={{
                                        borderRadius: '30px',
                                        fontSize: '16px',
                                        backgroundColor: '#ff9800 !important',
                                        textTransform: 'none',
                                        transition: 'all 0.7s ease-in-out',
                                        '&:hover': {
                                            boxShadow: '0 0 20px rgba(0,0,0,0.3)',
                                            transform: 'scale(1.1)'
                                        }
                                    }}
                                >
                                    Schedule A Free Consultation
                                    <span className="blob-btn__inner">
                                        <span className="blob-btn__blobs">
                                            <span className="blob-btn__blob"></span>
                                            <span className="blob-btn__blob"></span>
                                            <span className="blob-btn__blob"></span>
                                            <span className="blob-btn__blob"></span>
                                        </span>
                                    </span>

                                </Button>
                            </motion.div>

                        </div>
                        <motion.div
                            variants={fadeIn('left', 'tween', 0.2, 1.3)}
                            className='flex items-center justify-center relative z-30'
                        >
                            <img src={img} alt='img' 
                            className='w-[80%] h-[100%] md:w-[100%] md:h-[100%] object-contain cursor-pointer'
                            onClick={() => navigate('/contact-us')}
                            />
                        </motion.div>
                    </div>
                </motion.div>
            </div>
        </div >
    )
}

export default Banner